const getAndroidInterface = () => {
    try {
        return window.AndroidInterface || null;
    } catch (error) {
        console.warn('AndroidInterface access failed:', error);
        return null;
    }
};

const hasAndroidInterfaceMethod = methodName => {
    const androidInterface = getAndroidInterface();
    return Boolean(androidInterface && typeof androidInterface[methodName] === 'function');
};

const callAndroidInterfaceMethod = (methodName, ...args) => {
    const androidInterface = getAndroidInterface();
    if (!androidInterface || typeof androidInterface[methodName] !== 'function') {
        return undefined;
    }

    try {
        return androidInterface[methodName](...args);
    } catch (error) {
        console.error(`AndroidInterface.${methodName} failed:`, error);
        return undefined;
    }
};

export {
    callAndroidInterfaceMethod,
    getAndroidInterface,
    hasAndroidInterfaceMethod
};
